//social media
import {Mail, PhoneCall, Instagram} from "react-feather";
    import eitaaIcon from '@assets/images/icons/eitaa.png';
import soroushIcon from '@assets/images/icons/soroush.png';
import lamp from '../../images/advantage/best-employee.png';
import time from '../../images/advantage/time.png';
import price from '../../images/advantage/price.png';
import one from '../../images/advantage/one.png';

export const DETAILS = {
    name: "امداد خودرو 68",
    shortName: "امداد خودرو کرج",
    enName: "Emdad khodro",
    domain: "https://emdadkhodro68.com",
    description: "محصولات پروتئینی با طعم و کیفیت بی نظیر را با روزآوران تجربه کنید و سلامتی خود را حفظ کنید",
    shortAbout: "راننده گرامی در صورتی که به هر دلیلی نیاز به خدمات و سرویس های امداد خودرو دارید می توانید با شماره های زیر در تماس باشید.تماس با شماره مورد نظر به صورت شبانه روزی برای خدمات دهی در سطح شهر کرج فعال می باشد." ,
    veryShortAbout: "  ما به عنوان یک تولید کننده محصولات پروتئینی، از جمله سوسیس، کالباس، همبرگر و کباب لقمه، تلاش می کنیم تا نیازهای تغذیه ای شما را با بهترین کیفیت و خدمات حرفه ای برآورده کنیم. محصولات پروتئینی ما، تحت نظر یک کادر مجرب و متخصص در زمینه تولید و انتخاب مواد اولیه با کیفیت، تولید می شوند. هدف ما ارائه محصولاتی است که علاوه بر طعم عالی و لذیذ بودن، حاوی مقادیر مناسبی از پروتئین و مواد مغذی باشند.\n" +
        "\n" +
        "                            تمامی محصولات ما دارای استانداردهای بهداشتی لازم هستند و به صورت دقیق تحت نظر ناظرین بهداشتی بازرسی می شوند. اطمینان حاصل کنید که شما بهترین و سالم‌ترین محصولات را دریافت می کنید. ما به شدت به سلامتی و رضایت مشتریان خود اهمیت می‌دهیم و تمام تلاشمان را می‌کنیم تا محصولاتی را به بازار عرضه کنیم که نه تنها طعمی عالی داشته باشند، بلکه از لحاظ مقادیر غذایی و سلامتی هم به استانداردهای بالا پاسخگو باشند.\n",
    mobiles: [
        '09124611886',
        '09355420094'
    ],
    phones: [
        '09124611886',
        '09355420094'
    ],
    email: [],
    postalCode: [""],
    address: "",
    mapIframeSrc: "",
    socialMedia: [

        // {
        //     title: 'تلگرام',
        //     value: '09123456789',
        //     name: 'telegram',
        //     link: 'https://t.me/+9123456789',
        //     icon: <i className="lab la-telegram-plane"/>,
        //     isPrimary: true
        // },
        {
            title: 'اینستاگرام',
            value: 'mehditala548',
            name: 'instagram',
            link: 'https://www.instagram.com/mehditala548/',
            icon: <i className="lab la-instagram"/>,
            isPrimary: true
        },
        {
      title: 'واتس اپ',
      value: '09124611886',
      name: 'whatsapp',
      link: 'https://api.whatsapp.com/send/?phone=989124611886&text&app_absent=0',
      icon: <i className="lab la-whatsapp"/>,
      isPrimary: true
        },
        {
            title: 'ایتا',
            value: '09124611886',
            name: 'eitaa',
            link: 'https://eitaa.com/0989124611886',
            icon: <img src={eitaaIcon} alt='ایتا'/>,
            isPrimary: false
        },
        // {
        //     title: 'ایمیل',
        //     value: 'Volvotak@gmail.com',
        //     name: 'email',
        //     link: 'mailto:Volvotak@gmail.com',
        //     icon: <i className="las la-envelope"></i>,
        //     isPrimary: true
        // },
        // {
        //     title: 'تماس',
        //     value: '09133377432',
        //     name: 'phone',
        //     link: 'tel:989133377432',
        //     icon: <PhoneCall/>,
        //     isPrimary: true
        // },
        /*{
            title: 'آپارات',
            value: 'Alo_aghsat',
            name: 'aparat',
            link: 'https://www.aparat.com/Alo_aghsat',
            icon: <SiAparat size={25}/>,
            isPrimary: true
        },
        {
            title: 'تماس',
            value: '02636634893',
            name: 'phone',
            link: 'tel:+982636634893',
            icon: <PhoneCall/>,
            isPrimary: false
        },
        {
            title: 'سروش پلاس',
            value: '09331074475',
            name: 'soroushPlus',
            link: '',
            icon: <img src={soroushIcon} alt='سروش'/>,
            isPrimary: false
        },
        {
            title: 'سروش پلاس',
            value: '09332094475',
            name: 'soroushPlus',
            link: '',
            icon: <img src={soroushIcon} alt='سروش'/>,
            isPrimary: false
        },
        {
            title: 'سروش پلاس',
            value: '09330324475',
            name: 'soroushPlus',
            link: '',
            icon: <img src={soroushIcon} alt='سروش'/>,
            isPrimary: false
        },

        {
            title: 'ایتا',
            value: '09332094475',
            name: 'eitaa',
            link: '',
            icon: <img src={eitaaIcon} alt='ایتا'/>,
            isPrimary: false
        },
        {
            title: 'ایتا',
            value: '09330324475',
            name: 'eitaa',
            link: '',
            icon: <img src={eitaaIcon} alt='ایتا'/>,
            isPrimary: false
        }*/
    ],
    services: [],
    brands: [
        /*{
            name: 'Apple',
            image: <img src={appleImage} alt='apple'/>,
        },*/
    ],
    relatedLinks: [
        /* {
             title: 'بانک ملت',
             link: 'https://bankmellat.ir/',
             icon: <img src={MellatBankImage} alt='mellat-bank'/>,
         */
    ],
    advantage : [
        {
            title: 'سرعت در رسیدگی',
            image:lamp,
            description: 'اقدام سریع به افراد نیازمند خدمات',
        },
        {
            title: 'همیشه در دسترس',
            image:time,
            description: '24 ساعته، آماده ارائه خدمات',
        },
        {
            title: 'هزینه مناسب',
            image:price,
            description: 'خدمات دهی طبق تعرفه اتحادیه',
        },
        {
            title: 'تیم متخصص',
            image:one,
            description: 'داشتن تیم متخصص و مجهز امدادی',
        }
    ],
    "supportDescription": "",
    "workingHours": [],
    "__choose among these__": "",
    "enamadLink": true,
    "samandehiLink": "",
    "ZarinpalLink": "https://www.zarinpal.com/webservice/TrustCode"
}
